import React, { useState, useEffect } from "react";
import {
  Avatar,
  Box,
  Divider,
  Grid,
  IconButton,
  TextField,
  Typography,
} from "@mui/material";
import LocalPhoneOutlinedIcon from "@mui/icons-material/LocalPhoneOutlined";
import ChevronLeftOutlinedIcon from "@mui/icons-material/ChevronLeftOutlined";
import SendIcon from "@mui/icons-material/Send";
import { useSelector } from "react-redux";
import { getMessages, getSelectedChat } from "../Infrastructure/Chat.reducer";
import AlwaysScrollToBottom from "./AlwaysScrollToBottom.ui";
import Bubble from "./Bubble.ui";
import sendMessage from "../Application/sendMessage.logic";
import { useHistory } from "react-router-dom";

import { useDispatch } from "react-redux";
import { setSelectedChat } from "../Infrastructure/Chat.reducer";

import { GetPhotoProfile } from "../../User/Infrastructure/User.presenter";

const iconBtnStyles = {
  width: "70px",
  height: "31px",
  background: "#F2F2F2",
  borderRadius: "5px",
  color: "black",
}

const goBackIcon = {
  width: "34px",
  height: "34px",
  display: { lg: "none" },
  color: "#004990",
}

const userInfoStyles = {
  maxWidth: { xs: "200px", lg: "none"},
  textAlign: "left",
  whiteSpace: "nowrap",
  overflow: "hidden",
  textOverflow: "ellipsis"
}

const nameStyles = {
  fontSize: "24px",
  fontWeight: 500,
  lineHeight: "29px",
  letterSpacing: "0em",
}

export default function Conversation({classes}) {
  const { container, chat, bubbles } = classes;
  const dispatch = useDispatch();
  const selectedChat = useSelector(getSelectedChat);
  const history = useHistory();
  const messages = useSelector(getMessages);
  const [message, setMessage] = useState("");
  const [photo, setPhoto] = useState({});

  const userID = localStorage.getItem("userid");

  useEffect(() => {
    if (selectedChat) {
      getUrlPhoto(selectedChat.url_photoProfile)
    }
  }, [selectedChat]);

  const getUrlPhoto = async (urlPhoto) =>{
    const res = await GetPhotoProfile(urlPhoto);
    setPhoto(res);
  }

  return selectedChat ? (
    <Box md={7} item className={[container, chat]}>
      <Box className={[goBackIcon]}>
        <ChevronLeftOutlinedIcon sx={goBackIcon} onClick={() =>  {
          dispatch(setSelectedChat(null));
          history.push("/chat"); 
        }}/>
      </Box>
      <Box>
        <Box margin="1em">
          <Grid container sx={{ margin: 0}} alignItems="center">
            <Grid item xs={2} lg={2}>
              <Avatar alt={selectedChat.name} src={photo} />
            </Grid>
            <Grid item xs={8} lg={8}>
              <Box display="flex" flexDirection="column" justifyContent="start">
                <Typography sx={{...nameStyles, ...userInfoStyles}}>{`${selectedChat.name} ${selectedChat.last_name}`}</Typography>
                <Typography sx={userInfoStyles}>{selectedChat.email}</Typography>
              </Box>
            </Grid>
            <Grid item xs={2} lg={2}>
              <IconButton sx={iconBtnStyles}>
                <LocalPhoneOutlinedIcon />
              </IconButton>
            </Grid>
          </Grid>
        </Box>
        <Divider />
        <Box className={bubbles}>
          {messages?.map((record, index) => (
            <Bubble
              key={record.chat_id + index}
              isOwner={record.user_id.id === userID}
              message={record}
            />
          ))}
          <AlwaysScrollToBottom />
        </Box>
        <Box margin={"0.5em 0em"} display="flex">
          <TextField
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            fullWidth
            onKeyUp={(event) => {
              console.log(event.key);
              if (event.key === "Enter") {
                sendMessage(selectedChat.id, message, userID);
                setMessage("");
              }
            }}
          />
          <IconButton
            onClick={() => {
              sendMessage(selectedChat.id, message, userID);
              setMessage("");
            }}
          >
            <SendIcon />
          </IconButton>
        </Box>
      </Box>
    </Box>
  ) : (
    <></>
  );
}
